import { QueryFunction, useQuery } from '@tanstack/react-query';
import { useWeb3Context, Web3Context } from '../web3Context';
import { promiseFetchQuotePrice } from './fetchTokenPrice';
import { BigIntWithDecimals } from '@silo/types';

export const quotePriceKey = 'quotePrice';

type QuotePriceKey = [key: typeof quotePriceKey, web3Context: Web3Context];

const queryQuotePrice: QueryFunction<BigIntWithDecimals, QuotePriceKey> = async ({ queryKey }) => {
  const [, { chainId, contracts, clientProvider }] = queryKey;

  return promiseFetchQuotePrice({ chainId, provider: clientProvider, contracts });
};

/**
 * The mechanism for getting the quote token price is hard-coded to use the
 * uniswap contract, so it's safe to hard code this value as well
 */
export const QUOTE_TOKEN_PRICE_PROVIDER_NAME = 'Uniswap V3';

export const useQueryQuotePrice = (disabled = false) => {
  const web3Context = useWeb3Context();

  const { data } = useQuery(['quotePrice', web3Context!], queryQuotePrice, {
    enabled: !!web3Context && !disabled,
  });

  return data;
};
